export default __webpack_public_path__ + "static/media/icon-clock.81de8b0f.svg";